module.exports = __webpack_public_path__ + "img/b6d3884.png";